import React, { Fragment } from 'react';
import styled from 'styled-components';
import { TABLET_WIDTH } from '~~elements/Const';
import UploadField from '~~elements/UploadField';
import Input from '~~elements/Input';
import Button from '~~elements/Button';
import IconAttachment from '~~elements/static/IconAttachment.svg';
import { ImageWrapper, ImageDisplay } from '../styled';
import UTRMultilingual from '../../Multilingual';
import RMultilingual from '../../../Tournament/Registry/Multilingual';

export const StyledDiv = styled.div`
  width: 9rem;
  line-height: 1;
  padding: 1rem 0;
  text-align: start;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: start;
  align-self: flex-start;

  &.s {
    padding: 0.2rem 0;
  }

  @media (max-width: ${TABLET_WIDTH}) {
    width: 8rem;
    padding: 0.8rem 0;
    &.s {
      padding: 0.1rem 0;
    }
  }
`;

const Column = ({ column, onChange, apiInProgress, className = '' }) => {
  const handleInputChange = (e) => {
    onChange({ value: e.target.value, url: '' });
  };

  const handleImageUpdate = (data) => {
    onChange({ value: data.path, url: data.url, removedImage: column.value });
  };

  const handleRemoveImage = () => {
    onChange({ value: '', url: '', removedImage: column.value });
  };

  const getInput = () => {
    switch (column.type) {
      case 'TEXT':
        return <Input name={column.name} value={column.value} onChange={handleInputChange} disabled={apiInProgress} />;
      case 'DATE':
        return (
          <Input
            name={column.name}
            value={column.value}
            type="date"
            onChange={handleInputChange}
            disabled={apiInProgress}
          />
        );
      case 'IMAGE':
        if (apiInProgress) {
          return (
            <ImageWrapper avatarRatio={1}>
              <ImageDisplay url={column.url} />
            </ImageWrapper>
          );
        }
        return (
          <ImageWrapper avatarRatio={1}>
            <ImageDisplay url={column.url} />

            {column.value ? (
              <Fragment>
                <ImageDisplay url={column.url} />
                <UploadField
                  styleType="box"
                  url="/api/media"
                  customBtn={(onClick) => (
                    <Button width="unset" color="white" onClick={onClick}>
                      {UTRMultilingual(`FORM.REPLACE`)}
                    </Button>
                  )}
                  onChange={handleImageUpdate}
                />
                <Button width="unset" color="red" onClick={handleRemoveImage} mini>
                  {UTRMultilingual(`COMMON.REMOVE`)}
                </Button>
                <a href={column.url} target="_blank" rel="noopener noreferrer">
                  <Button width="unset" color="blue" mini>
                    {UTRMultilingual(`COMMON.VIEW`)}
                  </Button>
                </a>
              </Fragment>
            ) : (
              <UploadField
                styleType="box"
                url="/api/media"
                customBtn={(onClick) => (
                  <Button width="unset" color="blue" onClick={onClick}>
                    {UTRMultilingual(`FORM.UPLOAD`)}
                  </Button>
                )}
                onChange={handleImageUpdate}
              />
            )}
          </ImageWrapper>
        );
      case 'PDF':
        return (
          <label>
            <img src={IconAttachment} style={{ width: '1rem', height: '1rem' }} alt="attachIcon" />
            {!column.value ? (
              RMultilingual(`DOCUMENT.NONE`)
            ) : (
              <a href={column.url} target="_blank" rel="noopener noreferrer">
                {RMultilingual(`COMMON.VIEW`)}
              </a>
            )}
          </label>
        );
      default:
        return <></>;
    }
  };

  return (
    <StyledDiv className={className}>
      <label>
        {column.name}
        {column.is_required && <i>*</i>}
      </label>
      <label>
        <i className="info">{column.hint}</i>
      </label>
      {getInput()}
    </StyledDiv>
  );
};

export default Column;
